export const CampaignFormType = {
    FUEL: "FUEL",
    NORMAL: "NORMAL",
    HOTEL: "HOTEL"
}

export const VatType = {
    INCLUDED: "INCLUDED",
    EXCLUDED: "EXCLUDED"
}

export const CurrencyType = {
    TRY: {
        value: "TRY",
        suffix: "₺"
    },
    USD: {
        value: "USD",
        suffix: "$"
    },
    EURO: {
        value: "EUR",
        suffix: "€"
    }
};

export const resourcePrefixType = {
    tebeczacikart: "tebeczacikart",
    optikkart: "optikkart",
    kirmizikurumsal: "kirmizikurumsal"
}


// WEBPACK FOOTER //
// ./src/util/Enums.js